import { Chip } from '@mui/material';
import { AccountStatusDto } from 'src/dtos';
import { AccountStatus } from 'src/models';
import { ColorConstant } from 'src/styles';

const getAccountStatusTagPalette = (
  status: AccountStatusDto | 'NotSubmitted',
): { background: string; color: string } => {
  switch (status) {
    case AccountStatusDto.Complete:
      return { background: ColorConstant.GREEN2, color: ColorConstant.GREEN7 };
    case AccountStatusDto.Rejected:
    case AccountStatusDto.Suspended:
    case AccountStatusDto.Error:
    case AccountStatusDto.Canceled:
    case 'NotSubmitted':
      return { background: ColorConstant.RED2, color: ColorConstant.RED7 };
    default:
      return {
        background: ColorConstant.ORANGE1,
        color: ColorConstant.ORANGE7,
      };
  }
};

export const AccountStatusChip = ({ value }: { value: AccountStatus }) => {
  return <Chip label={value.label} sx={getAccountStatusTagPalette(value.value)} />;
};
